import LovrFire from '../lovrfire'
import firebase from 'firebase';


export const loadCommentNotifications = async (userID, observer) => {
    try {
        console.log("okay here we go")
        return LovrFire.firestore().collection('notifications')
            .doc(userID).collection('comments').orderBy('timestamp', 'desc').onSnapshot(observer)
    } catch (e) {
        console.log(e)
    }
}

export const loadLikeNotifications = async (userID, observer) => {
    try {
        return LovrFire.firestore().collection('notifications')
            .doc(userID).collection('likes').orderBy('timestamp', 'desc').onSnapshot(observer)
    } catch (e) {}
}

export const genNotificationToken = async (userID) => {
    try {
        await LovrFire.messaging().requestPermission();
        const token = await LovrFire.messaging().getToken({
            vapidKey: 'BEq_3gYlzoKGHVpq0lO4QGlxJg0myyGhfHI7eGLMa3EUmEl5Xb7Pj5fO4SYxx-1iLFKNr9FKiRKDJIvFMShfces'
        });
        console.log(token)
        await LovrFire.firestore().collection('users').doc(userID).update({
            token: token
        })
    } catch (e) {
        console.log(e)
    }
}